import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaTwitter, FaLinkedinIn, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-top">
          <Col lg={4} md={6} className="mb-5 mb-lg-0">
            <div className="footer-info">
              <h3 className="footer-logo">networkBuilder</h3>
              <p className="footer-description">
                Delivering comprehensive web solutions to help businesses establish a strong online presence.
              </p>
              <div className="social-links">
                <a href="https://www.youtube.com/@NetworkBuilderYT" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaYoutube />
                </a>
                <a href="https://x.com/NetworkBuilderr" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaTwitter />
                </a>
                <a href="https://www.linkedin.com/company/network-builder-solution/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaLinkedinIn />
                </a>
                <a href="https://www.instagram.com/networkbuilder__" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </Col>

          <Col lg={2} md={6} className="mb-5 mb-lg-0">
            <h4 className="footer-heading">Pages</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/testimonials">Testimonials</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="mb-5 mb-lg-0">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a href="#!">Custom Website Development</a></li>
              <li><a href="#!">Mobile Application Development</a></li>
              <li><a href="#!">UI/UX Design Services</a></li>
              <li><a href="#!">SEO Optimization</a></li>
              <li><a href="#!">Digital Marketing</a></li>
              <li><a href="#!">E-commerce Solutions</a></li>
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li>
                <FaMapMarkerAlt className="contact-icon" />
                <span>IT park Indore<br />Madhya Pradesh, INDIA</span>
              </li>
              <li>
                <FaPhone className="contact-icon" />
                <span>+91-6265167722 </span>
              </li>
              <li>
                <FaEnvelope className="contact-icon" />
                <span>info@networkBuilder.com</span>
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col>
            <div className="copyright">
              <p>© {currentYear} <strong>networkBuilder</strong>. All Rights Reserved.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer; 